import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function useDeleteDistributorUser() {
  const [loading, setLoading] = useState(false);
  async function execute(distributorUserId: string) {
    try {
      setLoading(true);
      await api.delete(`v1/backoffice/distributor-users/${distributorUserId}`);
      toast.success(
        ToastMessages.distributorUser.success.deleteDistributorUser,
      );
    } catch (error) {
      toast.error(ToastMessages.distributorUser.error.deleteDistributorUser);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
